/*
 * Public API Surface of catalean-version-controller
 */

export * from './lib/catalean-version-controller.service';
export * from './lib/catalean-version-controller.module';
